import axios from '@/plugins/api.request'

/**
 * 创建的团队列表
 * @param {*} data
 */
export const list = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.List',
    data
  })
}

/**
 * 创建团队
 * @param {*} data
 */
export const add = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.Create',
    data
  })
}

/**
 * 更新团队
 * @param {*} data
 */
export const update = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.Edit',
    data
  })
}

/**
 * 解散团队
 * @param {*} data
 */
export const disband = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.Disband',
    data
  })
}

/**
 * 团队成员列表
 * @param {*} data
 */
export const memberList = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.MemberList',
    data
  })
}

/**
 * 快速添加成员
 * @param {*} data
 */
export const addFastMember = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.AddFastMember',
    data
  })
}

/**
 * 添加成员
 * @param {*} data
 */
export const addMember = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.AddMember',
    data
  })
}

/**
 * 移除成员
 * @param {*} data
 */
export const delMember = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.MemberDelete',
    data
  })
}

/**
 * 退出团队
 * @param {*} data
 */
export const exitTeam = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.ExitTeam',
    data
  })
}